import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { placeOrder } from "./Utils";
import logo from '../Assets/Image/Thebook24.svg';

function PaymentStatus() {
    const BASE_URL = process.env.REACT_APP_PP_URL
    const key = localStorage.getItem('userId');
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const razorpayPaymentLinkId = params.get("razorpay_payment_link_id");
    const [status, setStatus] = useState();
    const [loading, setLoading] = useState(true);
    const reef = useRef(false);
    const navi = useNavigate();
    const getPaymentStatus = async () => {
        try {
            const res = await fetch(`${BASE_URL}/customer/v1/razorPay/updateStatus/${razorpayPaymentLinkId}`, {
                headers: {
                    "Authorization": `Bearer ${key}`
                }
            });
            const getRes = await res.json();
            console.log(getRes, "gerRes");
            if (getRes.errorCode === 0) {
                if (getRes.responsePacket.status === "paid") {
                    setStatus("paid");
                    setAction("Congratulations ! your payment has successfull");
                    placeOrderr(getRes.responsePacket.cartUuid, "paid");
                } else if (getRes.responsePacket.status === "created") {
                    getPaymentStatus();
                } else if (getRes.responsePacket.status === "opened") {
                    getPaymentStatus();
                } else if (getRes.responsePacket.status === "under_verification") {
                    getPaymentStatus();
                } else if (getRes.responsePacket.status === "expired") {
                    setAction("Oops! your payment link in expired");
                    setStatus(null);
                    setLoading(false);
                } else if (getRes.responsePacket.status === "cancelled") {
                    setAction("Oops! your payment cancelled");
                    setStatus(null);
                    setLoading(false);
                } else if (getRes.responsePacket.status === "failed") {
                    setAction("Oops! your payment is failed");
                    setStatus(null);
                    setLoading(false);
                }
            }
        } catch (e) {
            console.log(e, "error in payment status api");
            setAction("something went wrong !");
            setStatus(null);
            setLoading(false);
        }
    };
    useEffect(() => {
        getPaymentStatus();
    }, []);
    const [action, setAction] = useState();
    const placeOrderr = async (cartUuid, pay) => {
        try {
            const res = await placeOrder(cartUuid);
            if (res.errorCode === 0) {
                reef.current = true
                window.scrollTo({ top: 0, behavior: "smooth" });
                if (reef.current) {
                    localStorage.removeItem("userCart");
                }
                navi("/", { state: { paymentStatus: pay } });
            }
        } catch (e) {
            console.log(e, 'error in api place order');
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            {
                loading ?
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", position: "relative" }}>
                        <div style={{ textAlign: "center" }} className="logo-loading">
                        </div>
                        <img src={logo} alt="logo" width={200} height={200} style={{ position: "absolute" }} loading="lazy" />
                    </div>
                    :
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", position: "relative" }}>
                        <div style={{ textAlign: "center" }} >
                            <h1 style={{ textAlign: "center" }}>{action}</h1>
                            <button onClick={() => navi("/", { state: status })}></button>
                        </div>
                    </div>
            }
        </>
    )
}
export { PaymentStatus }